const detailPage = {
  helpText: '对您是否有帮助？',
  helpYes: '是',
  helpNo: '否',
  helpSubmitTipTxt: '我们已收到您的反馈，感谢您的反馈！',
  helpSubmitTipTxt2: '我们已收到您的反馈，感谢您帮助我们改进问题的答案！',
  helpFormTxt: {
    desc: '您对这个回答认为没有帮助的原因是？',
    optionList: [
      { value: '这个回答很难理解', text: '这个回答很难理解' },
      { value: '这个回答已经过时', text: '这个回答已经过时' },
      { value: '这个回答有点问题', text: '这个回答有点问题' },
    ],
    feedbackLabel: '额外反馈？',
    submitTxt: '提 交',
  },
  titleOne: '仍未解决您的问题？',
  contentOne: `
  无锡凯尔克在全国各地的技术服务中心超过三十个，采用就近服务的原则为客户提供各种快捷服务。<br />
  同时，总部的工程师和行业专家会提供专业的技术服务支持。
  `,
  callUsBtnText: '联系我们',
}


export default {
  title: '产品资源',
  tabs: [
    '企业宣传资料',
    '企业视频展示',
    '常见技术问题',
  ],
  copyText: '复制链接',
  placeholderTextOne: '搜索常见技术问题的标题和答案...',
  detailPage,
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/productPage.js